var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 1.485L22.515 0 12 10.515 1.485 0 0 1.485 10.515 12 0 22.515 1.485 24 12 13.484 22.515 24 24 22.515 13.484 12z"}));
}

IconClose.defaultProps = {"id":"icon-close","viewBox":"0 0 24 24"};

module.exports = IconClose;

IconClose.default = IconClose;
